var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 0C27.16 0 35 7.84 35 17.5C35 27.16 27.16 35 17.5 35C7.84 35 0 27.16 0 17.5C0 7.84 7.84 0 17.5 0ZM17.5 5.25C14.595 5.25 12.25 7.595 12.25 10.5C12.25 13.405 14.595 15.75 17.5 15.75C20.405 15.75 22.75 13.405 22.75 10.5C22.75 7.595 20.405 5.25 17.5 5.25ZM17.5 30.1C21.875 30.1 25.7425 27.86 28 24.465C27.9475 20.9825 21 19.075 17.5 19.075C14.0175 19.075 7.0525 20.9825 7 24.465C9.2575 27.86 13.125 30.1 17.5 30.1Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.a1e3a1ce9fdd650d161e4b3b8b1171a8.svg";
export { ForwardRef as ReactComponent };